// src/reducers/uidReducer.js
import {
    FETCH_ALL_UIDS_REQUEST,
    FETCH_ALL_UIDS_SUCCESS,
    FETCH_ALL_UIDS_FAILURE
} from '../actions/uidTypes';

const initialState = {
    loading: false,
    uids: [],
    error: '',
};

export const uidReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_UIDS_REQUEST:
            return { ...state, loading: true };
        case FETCH_ALL_UIDS_SUCCESS:
            return { loading: false, uids: action.payload, error: '' };
        case FETCH_ALL_UIDS_FAILURE:
            return { loading: false, uids: [], error: action.error };
        default:
            return state;
    }
};